export const maskCNPJ = (cnpj) => {
  if (cnpj === null || cnpj === undefined) return '';
    cnpj = cnpj.replace(/\D/g, "")
    cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2")
    cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2")
    cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2")
    return cnpj
};

export const maskPassport = (value) => {
  return value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
};

export const maskCPF = (cpf) => {
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
  //cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  cpf = cpf.replace(/(\d{3})(\d{3})/g, "$1.$2-");
  return cpf;
}
export const maskCPF2 = (cpf) => {
  if (cpf === null || cpf === undefined) return '';
  cpf = cpf.replace(/\D/g, "")
  if (cpf.length <= 11) {
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2") 
  }
  return  cpf
}

export const maskTEL = (tel) => {
  if(tel.length >= 14){
    tel = tel.replace(/\D/g, '')
    tel = tel.replace(/(\d{2})(\d)/, '($1) $2')
    tel = tel.replace(/(\d{5})(\d{4})/, '$1-$2')
  } else {
    tel = tel.replace(/\D/g, '')
    tel = tel.replace(/(\d{2})(\d)/, '($1) $2')
    tel = tel.replace(/(\d{4})(\d{4})/, '$1-$2')
  }
  return tel
}
export const maskCEP = (cep) => {
  cep = cep.replace(/\D/g, '')
  cep = cep.replace(/^(\d{5})(\d{3})+?$/, '$1-$2');
  
  return cep
}

export const maskCurrency = (value) => {
  if (value === null || value === undefined) return '';
  const digits = String(value).replace(/\D/g, '');
  const cents = Number(digits) / 100;
  return cents.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const parseCurrencyToNumber = (value) => {
  if (value === null || value === undefined) return 0;
  const digits = String(value).replace(/\D/g, '');
  return Number(digits) / 100;
};
